import React from "react";

/**
 * Small admin KPI tile. Extracted from src/pages/Admin.jsx unchanged so both the
 * Overview tab and the Billing Sync tab can share it.
 */
export default function Kpi({ label, value, tone = "default" }) {
  const tones = {
    default: "bg-white text-[#1F2A2E]",
    warn: "bg-[#FBF0DC] text-[#8A5A12]",
    danger: "bg-[#FBE6E4] text-[#B42318]",
    good: "bg-[#E4F3EA] text-[#14603C]",
  };
  return (
    <div className={`rounded-2xl border border-[#E3DED4] p-4 ${tones[tone]}`}>
      <p className="font-display text-2xl font-bold">{value}</p>
      <p className="text-xs mt-0.5 opacity-80">{label}</p>
    </div>
  );
}
